import React, { useEffect } from 'react';
import { 
  createBrowserRouter, 
  RouterProvider,
  createRoutesFromElements,
  Route,
  Outlet
} from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './css/ifia.css';
import './css/Spacers.css';
import './css/responsive.css';

// Components
import Header from './components/Common/Header';
import WelcomeHeader from './components/Common/WelcomeHeader';
import ScrollToTop from './components/Common/ScrollToTop';
import Footer from './components/Common/Footer';

// Pages
import Home from './pages/Home';
import DriversOfInnovation from './pages/DriversOfInnovation';

function Layout() {
  const params = new URLSearchParams(window.location.search);

  return (
    <>
      <ScrollToTop />
      <div className="content-wrapper">
        <Header />
        <WelcomeHeader />
        <Outlet />
        <Footer />
      </div>
    </>
  );
}

function AccessDenied() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h1>Access Denied</h1>
        <p>You do not have permission to access this resource.</p>
        <p style={{ fontSize: '14px', color: '#666' }}>
          Check your correspondence and follow the instructions.
        </p>
      </div>
    </div>
  );
}

function App() {
  const params = new URLSearchParams(window.location.search);
  const emailParam = params.get(process.env.REACT_APP_API_KEY_PARAM);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const hasValidAccess = emailParam && emailRegex.test(emailParam);

  
  if (!hasValidAccess) {
    return <AccessDenied />;
  }

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/drivers-of-innovation" element={<DriversOfInnovation />} />
      </Route>
    ),
    {
      future: {
        v7_startTransition: true
      }
    }
  );

  return <RouterProvider router={router} />;
}

export default App;
